module.exports = __webpack_public_path__ + "img/hype.ea94171d.png";